import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import EmergencyPatientSelection, { patientsPerPageOptions } from '@/pages/diagnostic/components/EmergencyPatientSelection'
import { PatientData } from '@/pages/patients/ui/PatientsTable'

export type StartLocalConsultationFormValues = {
  patient: string
  defaultEquipment?: string
}
export type StartLocalConsultationDialogProps = {
  onSearchPatient?: (value: string) => void
  open: boolean
  onClose: () => void
  loading: boolean
  onPageChange?: (newPage: number, rowsPerPage: number) => void
  patients: PatientData[]
  onPatientCreation?: () => void
  totalSearchCount: number
  onSelect?: (patientId: string) => void
}

export default function StartLocalConsultationDialog(props: StartLocalConsultationDialogProps) {
  const { onSearchPatient, open, onClose, loading, onPageChange, patients, onPatientCreation, totalSearchCount, onSelect } = props
  const { t } = useTranslation()
  const handleClose = () => {
    onClose()
  }

  const handleSearchPatient = useCallback(
    (inputValue: string) => {
      onSearchPatient?.(inputValue)
    },
    [onSearchPatient]
  )

  const handleChangePage = useCallback(
    (newPage: number) => {
      onPageChange?.(newPage, patientsPerPageOptions[0])
    },
    [onPageChange]
  )

  const handleCreatePatient = useCallback(() => {
    onPatientCreation?.()
  }, [onPatientCreation])


  return (
    <Dialog
      disablePortal
      open={open}
      onClose={(_event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason !== 'backdropClick') handleClose()
      }}
      PaperProps={{ sx: { maxWidth: (theme) => theme.breakpoints.values.sm, width: '100%', overflow: 'visible' } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
        {t('page.waitingRooms.reserveConsultationDialog.title')}
        <Tooltip title={t('common:button.close.tooltip')}>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent>
        <EmergencyPatientSelection
          isSearching={loading}
          onCreate={handleCreatePatient}
          onPageChange={handleChangePage}
          onSearch={handleSearchPatient}
          patients={patients}
          totalSearchCount={totalSearchCount || 0}
          onSelect={onSelect}
        />
      </DialogContent>
    </Dialog>
  )
}
